import { createContext, useContext, type ReactNode } from 'react';

export interface Announcement {
  message: ReactNode;
  actionLabel?: string;
  onAction?: () => void;
  durationMs?: number;
}

export interface HeldActionsApi {
  announce: (announcement: Announcement) => void;
}

export const HeldActionsContext = createContext<HeldActionsApi | null>(null);

export function useHeldActions(): HeldActionsApi {
  const context = useContext(HeldActionsContext);
  if (!context) throw new Error('useHeldActions must be used inside HeldActionsProvider');
  return context;
}
